import { useEffect, useState, useCallback } from "react";
import { Button, Col, Divider, Input, Row, Space } from "antd";
import { SearchOutlined, PlusOutlined, SyncOutlined } from "@ant-design/icons";

import { clientsIndex as index, client } from "../../data/Algolia";
import useTranslation from "../../intl/useTranslation";

const SearchClients = ({
	setClients,
	editClient,
	currentPage,
	setTotalResults,
	pageSize,
	setEditClient,
}) => {
	const [search, setSearch] = useState({ query: "" });
	const [searchInput, setSearchInput] = useState("");
	const [refreshLoading, setRefreshLoading] = useState(false);
	const { t } = useTranslation();

	const onChangeSearchQuery = (e) => setSearchInput(e.target.value);

	const queryAloglia = useCallback(async () => {
		const searchResult = await index.search(search.query, {
			page: currentPage - 1,
			hitsPerPage: pageSize,
			cacheable: false,
		});
		setTotalResults(searchResult.nbHits);
		setClients(Object.values(searchResult.hits));
	}, [search.query, setClients, currentPage, pageSize, setTotalResults]);

	useEffect(() => {
		queryAloglia();
	}, [search, queryAloglia]);

	useEffect(() => {
		if (refreshLoading) {
			queryAloglia();
			setRefreshLoading(false);
		}
	}, [refreshLoading, queryAloglia]);

	useEffect(() => {
		queryAloglia();
	}, [queryAloglia, currentPage, pageSize]);

	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			if (search.query !== searchInput)
				setSearch({ ...search, query: searchInput });
		}, 400);

		return () => clearTimeout(delayDebounceFn);
	}, [searchInput, search]);

	useEffect(() => {
		if (editClient === null)
			client.clearCache().then(() => {
				queryAloglia();
			});
	}, [editClient, queryAloglia]);

	return (
		<Space direction="vertical" className="search-wrapper" size={16}>
			<Row>
				<Col lg={12}>
					<Input
						size="large"
						placeholder={t("clients.searchPlaceholder")}
						className="search-input"
						suffix={<SearchOutlined />}
						onChange={onChangeSearchQuery}
					/>
				</Col>
				<Col flex="auto" />
				<Col>
					<Space>
						<Button
							size="large"
							loading={refreshLoading}
							onClick={() => setRefreshLoading(true)}
							icon={<SyncOutlined />}
						/>
						<Button
							size="large"
							onClick={() =>
								setEditClient({
									phoneLocale: "CH",
									contacts: [{ country: "CH" }],
								})
							}
							icon={<PlusOutlined />}
						>
							{t("clients.actionNew")}
						</Button>
					</Space>
				</Col>
			</Row>
			<Divider />
		</Space>
	);
};

export default SearchClients;
